import { createContext, useContext, useState } from "react";

const translations = {
  pt: {
    // General
    app_name: "Lumora",
    dashboard: "Painel",
    pos: "POS",
    tables: "Mesas",
    orders: "Pedidos",
    products: "Produtos",
    categories: "Categorias",
    stock: "Stock",
    employees: "Funcionários",
    invoices: "Faturas",
    reports: "Relatórios",
    settings: "Definições",
    logout: "Sair",
    
    // Auth
    login: "Entrar",
    register: "Registar",
    email: "Email",
    password: "Palavra-passe",
    name: "Nome",
    login_with_google: "Entrar com Google",
    no_account: "Não tem conta?",
    have_account: "Já tem conta?",
    language: "Idioma",
    currency: "Moeda",
    
    // Dashboard
    today_sales: "Vendas Hoje",
    total_orders: "Total Pedidos",
    avg_ticket: "Ticket Médio",
    tables_occupied: "Mesas Ocupadas",
    open_orders: "Pedidos Abertos",
    top_products: "Produtos Mais Vendidos",
    sales_last_7_days: "Vendas Últimos 7 Dias",
    
    // Tables
    table: "Mesa",
    free: "Livre",
    occupied: "Ocupada",
    reserved: "Reservada",
    cleaning: "Limpeza",
    capacity: "Lugares",
    
    // Orders
    order: "Pedido",
    new_order: "Novo Pedido",
    add_items: "Adicionar Itens",
    subtotal: "Subtotal",
    tax: "IVA",
    total: "Total",
    pay: "Pagar",
    cash: "Dinheiro",
    card: "Cartão",
    split_bill: "Dividir Conta",
    print_receipt: "Imprimir Recibo",
    
    // Products
    product: "Produto",
    price: "Preço",
    description: "Descrição",
    available: "Disponível",
    popular: "Popular",
    modifiers: "Modificadores",
    
    // Stock
    ingredient: "Ingrediente",
    current_stock: "Stock Atual",
    min_stock: "Stock Mínimo",
    unit: "Unidade",
    supplier: "Fornecedor",
    low_stock_alert: "Alerta Stock Baixo",
    
    // Common
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Adicionar",
    search: "Pesquisar",
    filter: "Filtrar",
    all: "Todos",
    none: "Nenhum",
    loading: "A carregar...",
    error: "Erro",
    success: "Sucesso",
    confirm: "Confirmar",
    back: "Voltar",
    next: "Seguinte",
    previous: "Anterior",
    
    // Status
    open: "Aberto",
    preparing: "A preparar",
    ready: "Pronto",
    completed: "Concluído",
    cancelled: "Cancelado",
    pending: "Pendente",
    paid: "Pago",
    
    // Cash
    open_cash: "Abrir Caixa",
    close_cash: "Fechar Caixa",
    opening_balance: "Saldo Inicial",
    closing_balance: "Saldo Final",
    total_cash: "Total Dinheiro",
    total_card: "Total Cartão",
    
    // AI
    ai_predictions: "Previsões IA",
    sales_prediction: "Previsão de Vendas",
    stock_suggestions: "Sugestões de Stock",
    generate: "Gerar",
  },
  en: {
    // General
    app_name: "Lumora",
    dashboard: "Dashboard",
    language: "Language",
    currency: "Currency",
    pos: "POS",
    tables: "Tables",
    orders: "Orders",
    products: "Products",
    categories: "Categories",
    stock: "Stock",
    employees: "Employees",
    invoices: "Invoices",
    reports: "Reports",
    settings: "Settings",
    logout: "Logout",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    login_with_google: "Login with Google",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    
    // Dashboard
    today_sales: "Today's Sales",
    total_orders: "Total Orders",
    avg_ticket: "Avg Ticket",
    tables_occupied: "Tables Occupied",
    open_orders: "Open Orders",
    top_products: "Top Products",
    sales_last_7_days: "Sales Last 7 Days",
    
    // Tables
    table: "Table",
    free: "Free",
    occupied: "Occupied",
    reserved: "Reserved",
    cleaning: "Cleaning",
    capacity: "Capacity",
    
    // Orders
    order: "Order",
    new_order: "New Order",
    add_items: "Add Items",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",
    pay: "Pay",
    cash: "Cash",
    card: "Card",
    split_bill: "Split Bill",
    print_receipt: "Print Receipt",
    
    // Products
    product: "Product",
    price: "Price",
    description: "Description",
    available: "Available",
    popular: "Popular",
    modifiers: "Modifiers",
    
    // Stock
    ingredient: "Ingredient",
    current_stock: "Current Stock",
    min_stock: "Min Stock",
    unit: "Unit",
    supplier: "Supplier",
    low_stock_alert: "Low Stock Alert",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    filter: "Filter",
    all: "All",
    none: "None",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    
    // Status
    open: "Open",
    preparing: "Preparing",
    ready: "Ready",
    completed: "Completed",
    cancelled: "Cancelled",
    pending: "Pending",
    paid: "Paid",
    
    // Cash
    open_cash: "Open Cash",
    close_cash: "Close Cash",
    opening_balance: "Opening Balance",
    closing_balance: "Closing Balance",
    total_cash: "Total Cash",
    total_card: "Total Card",
    
    // AI
    ai_predictions: "AI Predictions",
    sales_prediction: "Sales Prediction",
    stock_suggestions: "Stock Suggestions",
    generate: "Generate",
  },
  es: {
    // General
    app_name: "Lumora",
    dashboard: "Panel",
    language: "Idioma",
    currency: "Moneda",
    pos: "POS",
    tables: "Mesas",
    orders: "Pedidos",
    products: "Productos",
    categories: "Categorías",
    stock: "Stock",
    employees: "Empleados",
    invoices: "Facturas",
    reports: "Informes",
    settings: "Configuración",
    logout: "Salir",
    
    // Auth
    login: "Entrar",
    register: "Registrar",
    email: "Email",
    password: "Contraseña",
    name: "Nombre",
    login_with_google: "Entrar con Google",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    
    // Dashboard
    today_sales: "Ventas Hoy",
    total_orders: "Total Pedidos",
    avg_ticket: "Ticket Medio",
    tables_occupied: "Mesas Ocupadas",
    open_orders: "Pedidos Abiertos",
    top_products: "Productos Más Vendidos",
    sales_last_7_days: "Ventas Últimos 7 Días",
    
    // Tables
    table: "Mesa",
    free: "Libre",
    occupied: "Ocupada",
    reserved: "Reservada",
    cleaning: "Limpieza",
    capacity: "Capacidad",
    
    // Orders
    order: "Pedido",
    new_order: "Nuevo Pedido",
    add_items: "Añadir Items",
    subtotal: "Subtotal",
    tax: "IVA",
    total: "Total",
    pay: "Pagar",
    cash: "Efectivo",
    card: "Tarjeta",
    split_bill: "Dividir Cuenta",
    print_receipt: "Imprimir Recibo",
    
    // Products
    product: "Producto",
    price: "Precio",
    description: "Descripción",
    available: "Disponible",
    popular: "Popular",
    modifiers: "Modificadores",
    
    // Stock
    ingredient: "Ingrediente",
    current_stock: "Stock Actual",
    min_stock: "Stock Mínimo",
    unit: "Unidad",
    supplier: "Proveedor",
    low_stock_alert: "Alerta Stock Bajo",
    
    // Common
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Añadir",
    search: "Buscar",
    filter: "Filtrar",
    all: "Todos",
    none: "Ninguno",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    confirm: "Confirmar",
    back: "Volver",
    next: "Siguiente",
    previous: "Anterior",
    
    // Status
    open: "Abierto",
    preparing: "Preparando",
    ready: "Listo",
    completed: "Completado",
    cancelled: "Cancelado",
    pending: "Pendiente",
    paid: "Pagado",
    
    // Cash
    open_cash: "Abrir Caja",
    close_cash: "Cerrar Caja",
    opening_balance: "Saldo Inicial",
    closing_balance: "Saldo Final",
    total_cash: "Total Efectivo",
    total_card: "Total Tarjeta",
    
    // AI
    ai_predictions: "Predicciones IA",
    sales_prediction: "Predicción de Ventas",
    stock_suggestions: "Sugerencias de Stock",
    generate: "Generar",
  },
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem("language");
    return stored || "pt";
  });

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
